// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.member-list-panel {
  width: 260px;
  background-color: var(--bg-tertiary);
  border-left: 1px solid var(--glass-border);
  display: flex;
  flex-direction: column;
  z-index: 50;
  position: relative;
}

.member-list-header {
  height: var(--header-height);
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--glass-border);
  background-color: var(--bg-tertiary);
}

.header-label {
  font-size: 11px;
  font-weight: 900;
  color: var(--text-primary);
  letter-spacing: 1.5px;
  opacity: 0.8;
}

.header-badge {
  background-color: var(--brand-primary);
  color: white;
  font-size: 10px;
  font-weight: 800;
  padding: 3px 10px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(153, 27, 27, 0.3);
}

.member-list-viewport {
  flex: 1;
  overflow-y: auto;
  padding: 24px 12px;
  scrollbar-width: none;
}

.member-list-viewport::-webkit-scrollbar {
  display: none;
}

.member-section {
  margin-bottom: 32px;
}

.section-header {
  font-size: 11px;
  font-weight: 900;
  color: var(--text-muted);
  padding: 0 14px 12px;
  letter-spacing: 1px;
  opacity: 0.6;
}

.member-item-professional {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 14px;
  border-radius: 14px;
  cursor: pointer;
  transition: all var(--transition-normal);
  margin-bottom: 4px;
  border: 1px solid transparent;
}

.member-item-professional:hover {
  background-color: var(--bg-modifier-hover);
  border-color: var(--glass-border);
  transform: translateX(-4px);
}

.member-avatar-box {
  position: relative;
  flex-shrink: 0;
}

.avatar-frame {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: var(--bg-secondary);
  border: 1.5px solid var(--glass-border);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-normal);
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.member-item-professional:hover .avatar-frame {
  border-color: var(--brand-primary);
  transform: scale(1.05);
}

.avatar-initial {
  font-size: 15px;
  font-weight: 800;
  color: var(--brand-light);
}

.status-indicator-dot {
  position: absolute;
  bottom: -3px;
  right: -3px;
  width: 14px;
  height: 14px;
  border-radius: 5px;
  border: 3px solid var(--bg-tertiary);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.member-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.member-name {
  font-size: 14px;
  font-weight: 800;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: -0.01em;
}

.member-status-text {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.5;
}

.member-actions-mini {
  display: none;
  gap: 8px;
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  background: var(--bg-tertiary);
  padding: 4px;
  border-radius: 8px;
  border: 1px solid var(--glass-border);
  box-shadow: var(--shadow-md);
}

.member-item-professional:hover .member-actions-mini {
  display: flex;
}

.action-mini-btn {
  background: transparent;
  border: none;
  color: var(--text-muted);
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.action-mini-btn:hover {
  color: var(--brand-primary);
  background: var(--bg-modifier-hover);
}

.member-name-row {
  display: flex;
  align-items: center;
  min-width: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/MemberList/MemberList.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,oCAAoC;EACpC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".member-list-panel {\n  width: 260px;\n  background-color: var(--bg-tertiary);\n  border-left: 1px solid var(--glass-border);\n  display: flex;\n  flex-direction: column;\n  z-index: 50;\n  position: relative;\n}\n\n.member-list-header {\n  height: var(--header-height);\n  padding: 0 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--glass-border);\n  background-color: var(--bg-tertiary);\n}\n\n.header-label {\n  font-size: 11px;\n  font-weight: 900;\n  color: var(--text-primary);\n  letter-spacing: 1.5px;\n  opacity: 0.8;\n}\n\n.header-badge {\n  background-color: var(--brand-primary);\n  color: white;\n  font-size: 10px;\n  font-weight: 800;\n  padding: 3px 10px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(153, 27, 27, 0.3);\n}\n\n.member-list-viewport {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px 12px;\n  scrollbar-width: none;\n}\n\n.member-list-viewport::-webkit-scrollbar {\n  display: none;\n}\n\n.member-section {\n  margin-bottom: 32px;\n}\n\n.section-header {\n  font-size: 11px;\n  font-weight: 900;\n  color: var(--text-muted);\n  padding: 0 14px 12px;\n  letter-spacing: 1px;\n  opacity: 0.6;\n}\n\n.member-item-professional {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 10px 14px;\n  border-radius: 14px;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  margin-bottom: 4px;\n  border: 1px solid transparent;\n}\n\n.member-item-professional:hover {\n  background-color: var(--bg-modifier-hover);\n  border-color: var(--glass-border);\n  transform: translateX(-4px);\n}\n\n.member-avatar-box {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.avatar-frame {\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  background: var(--bg-secondary);\n  border: 1.5px solid var(--glass-border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n  transition: all var(--transition-normal);\n}\n\n.avatar-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.member-item-professional:hover .avatar-frame {\n  border-color: var(--brand-primary);\n  transform: scale(1.05);\n}\n\n.avatar-initial {\n  font-size: 15px;\n  font-weight: 800;\n  color: var(--brand-light);\n}\n\n.status-indicator-dot {\n  position: absolute;\n  bottom: -3px;\n  right: -3px;\n  width: 14px;\n  height: 14px;\n  border-radius: 5px;\n  border: 3px solid var(--bg-tertiary);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.member-details {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.member-name {\n  font-size: 14px;\n  font-weight: 800;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  letter-spacing: -0.01em;\n}\n\n.member-status-text {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  opacity: 0.5;\n}\n\n.member-actions-mini {\n  display: none;\n  gap: 8px;\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: var(--bg-tertiary);\n  padding: 4px;\n  border-radius: 8px;\n  border: 1px solid var(--glass-border);\n  box-shadow: var(--shadow-md);\n}\n\n.member-item-professional:hover .member-actions-mini {\n  display: flex;\n}\n\n.action-mini-btn {\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.action-mini-btn:hover {\n  color: var(--brand-primary);\n  background: var(--bg-modifier-hover);\n}\n\n.member-name-row {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
